/** Łączy klasy, pomijając falsy. Bez zależności. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
